import React from 'react';
import SlideLayout from '../layouts/SlideLayout';
import { CoverSlideProps } from '../types';
import '../styles/CoverSlide.css';

const CoverSlide: React.FC<CoverSlideProps> = ({ title, subtitle, footer }) => {
  return (
    <SlideLayout
      backgroundColor="#0000FF"
      footer={footer}
      className="cover-slide"
    >
      <div className="cover-content">
        <h1 className="cover-title">{title}</h1>
        {subtitle && <p className="cover-subtitle">{subtitle}</p>}
      </div>
    </SlideLayout>
  );
};

export default CoverSlide;
